import { Position, State } from 'src/types'
// 背面の描画
import { lace } from 'src/features/brands/treasure/canvas/glove/back/lace'
import { lining } from 'src/features/brands/treasure/canvas/glove/back/lining'
import { littleHook } from 'src/features/brands/treasure/canvas/glove/back/hooks/littleHook'
import { thumbHook } from 'src/features/brands/treasure/canvas/glove/back/hooks/thumbHook'
import { backLaceDrawer, brandLabelDrawerForGlove } from 'src/features/brands/treasure/canvas/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/brands/treasure/canvas/glove/back/web/useCanvasWebsBack'
import {
  bottomRightOfBeltEmbroideryDrawer,
  liningEmbroideryDrawer,
  nonThumbEmbroideryDrawer,
  sideOfLabelEmbroideryDrawer
} from 'src/features/brands/treasure/canvas/common/back/useCanvasEmbroideries'
import { backStyleOfGloveBackDrawer } from 'src/features/brands/treasure/canvas/glove/back/backStyles'
import { laceOfWristBeltCrossDrawer, laceOfWristBeltStraightDrawer } from 'src/features/brands/treasure/canvas/glove/back/lace/laceOfWristBeltFix'
import { canvasResetter } from 'src/features/brands/treasure/canvas/common/canvasResetter'
import { backStyleChecker } from 'src/util/useModelDesign'
import { fingerCoverDrawer } from './fingerCoverOrPad'

export const treasureCanvasGloveBack = (ctx: CanvasRenderingContext2D, state: State, position: Position): void => {
  const { isFirstBackStyle } = backStyleChecker(state.backStyle?.value)
  const needCatchFaceWrap = (!state.baseModel?.isUBack && !isFirstBackStyle) || false
  // リセット
  canvasResetter(ctx)
  // 裏革
  lining(ctx, state.linings?.color)
  // 平裏の刺繍描画1段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'second')
  // バックスタイルの描画(ハミダシ,親指刺繍含)
  backStyleOfGloveBackDrawer(ctx, state, needCatchFaceWrap)
  // 指カバー
  fingerCoverDrawer(ctx, state?.fingerGuardType, position, state.indexCover?.color, state.stitch?.color)

  // RAG, Treasure＿ベルト右下への刺繍
  bottomRightOfBeltEmbroideryDrawer(ctx, state.embroideries, 0, 0)
  // Treasure＿ラベル左への刺繍
  sideOfLabelEmbroideryDrawer(ctx, state.embroideries, 0, 0)
  // 中指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'middleFinger', state.embroideries)
  // 薬指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'ringFinger', state.embroideries)
  // 小指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'childFinger', state.embroideries)
  // ウェブの描画
  webOfGloveBackDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color)
  if (state?.beltType?.value !== 'thumbOver' && ![state.backStyle?.value, state?.baseModel?.backStyle].includes('firstBackStyle')) {
    laceOfWristBeltCrossDrawer(ctx, state.lace?.color, isFirstBackStyle)
  }
  if (state?.beltType?.value === 'thumbOver') {
    laceOfWristBeltStraightDrawer(ctx, state.lace?.color, isFirstBackStyle)
  }
  // 背面紐通し(オプション)
  backLaceDrawer(ctx, state?.backLace?.value, state.lace?.color, position)
  // ラベル描画
  // brandLabelDrawerForGlove(ctx, state, 'treasure')
  // 小指掛け紐
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元
  // circleHollowOutEmbroideryDrawer(ctx, state.embroideries)
}
